import { css } from "@emotion/css";
import type { CSSProperties } from "react";
import React from "react";

interface Props {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  all?: number;
  /**
   * Set margin-left in px on every child except the first
   */
  betweenX?: number;
  /**
   * Set margin-top in px on every child except the first
   */
  betweenY?: number;
  display?: "flex" | "inline-block" | "block";
  className?: string;
  component?: keyof React.JSX.IntrinsicElements;
  style?: CSSProperties;
  children?: React.ReactNode;
}

export const Margin = ({
  all,
  betweenX,
  betweenY,
  children,
  bottom,
  className,
  component = "div",
  display,
  left,
  right,
  style,
  top,
}: // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  Props) => {
  const margins = top || right || bottom || left
    ? {
      marginTop: top || all,
      marginRight: right || all,
      marginBottom: bottom || all,
      marginLeft: left || all,
    }
    : { margin: all };

  const childMargin = betweenX || betweenY
    ? {
      ["& > * + *"]: {
        marginLeft: betweenX,
        marginTop: betweenY,
      },
    }
    : {};

  const internalClassName = css({
    display,
    ...margins,
    ...childMargin,
  });

  return React.createElement(component, {
    style,
    className: [internalClassName, className].join(" ").trim(),
    children,
    "data-component-type": "Margin",
  });
};
